import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import HTTP from '@/api/config'
import  VueAwesomeSwiper from 'vue-awesome-swiper'
import  'assets/css/swiper.css'
Vue.use(VueAwesomeSwiper)
Vue.prototype.$http = HTTP
Vue.prototype.$host = 'http://admin.4008005216.com/'
Vue.prototype.$url = 'http://user.4008005216.com'
// Vue.prototype.$url = 'http://192.168.0.32:8081'
Vue.use(Element, { size: 'small', zIndex: 3000 });

import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


Vue.use(VueQuillEditor)

import axios from 'axios'
Vue.prototype.axios = axios

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

//通过components下的index.js文件导入组件
import components from './views/index';
//对导入的组件进行全局组件注册
Object.keys(components).forEach((key) => {
	Vue.component(key, components[key])
});

router.beforeEach((to,form,next)=>{
	if(to.meta.title){
		document.title = to.meta.title;
	}
	next();
})
// Vue.use(Swiper)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
